import { TZDate } from '@date-fns/tz';

export enum AppointmentSchedulerView {
  DateTypePicker = 'DateTypePicker',
  MeetingTypePicker = 'MeetingTypePicker',
}

export type HostInfo = {
  id: string;
  display_name: string;
  image_url: string;
};

// An object containing little information about the host,
// and an array of strings
// (e.g. ["2026-01-08T14:00:00-05:00", "2026-01-08T14:15:00-05:00"])
// indicating available meeting slots on a given day for that host.
type HostAvailability = { hostInfo: HostInfo; times: string[] };

// Represents the availability of a host (coach or provider)
// in a given day.
//
// - Key: the id of the host leading the meeting
// - Value: an object containing the host info
//   and the available time slots for the meeting
export type HostAvailabilityRecord = Record<string, HostAvailability>;

// Represents the availability of a host (coach or provider), grouped by day.
//
// - Key: a date string in the format "YYYY-MM-DD" (e.g. "2026-01-08")
// - Value: a record made by objects in which the key is the id of the host,
//   and the value is another record with information for the meeting.
export type AvailabilityMap = Record<string, HostAvailabilityRecord>;

// Represents a key-value pair of the selected date and its availability details.
// - Key: a string representing the day in "YYYY-MM-DD" format (e.g., "2025-07-03")
// - Value: an object with:
//   - date: a TZDate object representing the full date, including timezone info
//   - records containing the availabilities of different hosts in that day
export type DateSelection = Record<string, DateSelectionValue>;
type DateSelectionValue = { date: TZDate } & HostAvailabilityRecord;
